<template>
    <span>
        <slot></slot>
        <div>
            <table class="table">
                <thead>
                <tr>
                    <th>#</th>
                    <th v-for="row in table">
                        {{ row.label }}
                    </th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data, key) of value">
                    <td>{{ key + 1 }}</td>
                    <td v-for="row in table">
                        <span v-if="row.type === 'text'">
                            <input type="text" v-model="value[key][row.name]">
                        </span>
                        <span v-if="row.type === 'number'">
                            <input type="number" v-model="value[key][row.name]">
                        </span>
                        <span v-if="row.type === 'date'" class="datepicker">
                            <input type="date" v-model="value[key][row.name]">
                        </span>
                        <span v-if="row.type === 'select'">
                            <select v-model="value[key][row.name]">
                                <option value=""></option>
                                <option v-for="(o, v) in row.options" :value="v">{{ o }}</option>
                            </select>
                        </span>
                        <span v-if="row.type === 'select2'">
                            <select v-model="value[key][row.name]" class="select2" :data-key="key" :data-name="row.name">
                                <option value=""></option>
                                <option v-for="(o, v) in row.options" :value="v">{{ o }}</option>
                            </select>
                        </span>
                    </td>
                    <td>
                        <button class="btn-danger btn-sm" v-on:click.prevent="deleteRow(key)">刪除</button>
                    </td>
                </tr>
                </tbody>
            </table>
            <button type="button" class="btn btn-info" v-on:click="addRow">+</button>
        </div>
        <div class="hidden-input hidden">
            <table>
                <tr v-for="(data, key) in value">
                    <td v-for="(column, name) in data">
                        <label>{{ name }}
                            <input type="text" v-model="value[key][name]" :name="generateName(name, [key, name])">
                        </label>
                    </td>
                </tr>
            </table>
        </div>
    </span>
</template>

<script>
  export default {
    computed: {
      names: function () {
        let names = [];
        this.table.forEach(function (item) {
          names.push(item.name);
        });
        return names;
      },
    },
    props: {
      'primary-key': String,
      table: {
        type: Array,
      },
      'default-value': {
        type: Array,
      },
      'name': {
        type: String,
      }
    },
    data() {
      const id = 'array' + Math.floor(Math.random() * 100)
      return {
        'value': [],
        'id': id,
        'inputDOM': null,
      };
    },
    mounted() {
      let value = [];
      this.defaultValue.forEach((item, key) => {
        value[key] = {};
        value[key][this.primaryKey] = item[this.primaryKey];
        Object.keys(item).forEach((item_value) => {
          if (this.names.indexOf(item_value) !== -1) {
            value[key][item_value] = item[item_value];
          }
        })
      });
      this.value = value;
    },
    updated() {
      this.$nextTick(function () {
        $(this.$el).find('.select2').select2({});
        $(this.$el).find('.select2').off();
        $(this.$el).find('.select2').on('change', (function (e) {
          let row = e.target.dataset.key;
          let name = e.target.dataset.name;
          this.value[row][name] = e.target.value;
          this.inputDOM.value = JSON.stringify(this.value);
          this.$forceUpdate()
        }).bind(this));
      });
    },
    methods: {
      deleteRow: function (rowId) {
        this.value.splice(rowId, 1);
      },
      addRow: function () {
        let row = {};
        row[this.primaryKey] = '';
        this.table.forEach(function (item) {
          row[item.name] = '';
        });
        this.value.push(row);
      },
      generateName: function (name, pathes) {
        let inputName = this.name;

        pathes.forEach((item) => {
          inputName += '[' + item + ']';
        });

        return inputName;
      },
    },
    watch: {
      value: function (value) {},
    }
  }
</script>
